import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
          准备好让你的品牌被更多人看见了吗？
        </h2>
        <p className="text-base text-foreground-600 max-w-xl mx-auto mb-10 leading-relaxed">
          果冻传媒的创意团队已经准备好，让我们聊聊你的品牌故事，一起创造令人心动的传播内容。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about#contact"
            className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-base font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            立即咨询
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 rounded-lg text-base font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}